import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../../hooks/useAuth'
import { PageHeader } from '../../components/PageHeader/PageHeader'
import { CreateEntityForm } from '../../components/CreateEntityForm/CreateEntityForm'
import { PageLoadingShell } from '../PageLoadingShell/PageLoadingShell'
import type { CreateEntityPageProps } from './CreateEntityPage.types'

export function CreateEntityPage({
  title,
  backTo,
  loadingLabel,
  loadError = null,
  note,
  fields,
  createFn,
  isLoading = false,
  extraRow,
  isExtraRowValid,
}: CreateEntityPageProps) {
  const { getToken } = useAuth()
  const navigate = useNavigate()
  const [submitError, setSubmitError] = useState<string | null>(null)

  async function handleSubmit(body: Record<string, unknown>) {
    setSubmitError(null)
    try {
      await createFn(await getToken(), body)
      navigate(backTo)
    } catch (err) {
      setSubmitError(
        err instanceof Error ? err.message : `Failed to ${title.toLowerCase()}`
      )
    }
  }

  return (
    <>
      <PageHeader title={title} />
      <PageLoadingShell
        loadingLabel={loadingLabel ?? title.toLowerCase()}
        isLoading={isLoading}
        error={loadError}
      >
        <section
          className="content-card content-card--padded"
          aria-label={title}
        >
          {note && (
            <div className="alert alert-info" role="note">
              {note}
            </div>
          )}
          {submitError && (
            <div className="alert alert-danger" role="alert">
              <strong>Error:</strong> {submitError}
            </div>
          )}
          <CreateEntityForm
            fields={fields}
            onSubmit={handleSubmit}
            isLoading={isLoading}
            extraRow={extraRow}
            isExtraRowValid={isExtraRowValid}
          />
        </section>
      </PageLoadingShell>
    </>
  )
}
